import { Component, OnInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { DataService } from '../../services/data.service';
import { StoreService } from '../../services/store.service';
import { ToolsService } from '../../services/tools.service';
import { BaseComponent } from '../base-components/base-component';
import { ActivatedRoute, Router } from '@angular/router';
import { ShoppingCart } from '../../models/models';
import { pages } from '../../alv-enums';
import { CountdownComponent, Config } from 'ngx-countdown';
import { Utility } from 'src/app/common/utility';

@Component({
	selector: 'register',
	templateUrl: './register.component.html',
	styleUrls: ['./register.component.scss']
})
export class RegisterComponent extends BaseComponent implements OnInit {
	@ViewChild('timerModalLink') timerModalLink: ElementRef;
	@ViewChild(CountdownComponent) cd1: CountdownComponent;

	public currentPage: pages;
	private timeout: any;

	/** This is here to allow the html code to access the pages enum. */
	public pagesEnum: any;

	constructor(dataService: DataService
		, storeService: StoreService
		, toolsService: ToolsService
		, activatedRoute: ActivatedRoute
		, router: Router
	) {
		super(dataService, storeService, toolsService, activatedRoute,router);

		this.pagesEnum = pages;
		this.currentPage = pages.Order;
	}

	ngOnInit() {
		const self = this;

		// immediately wipe this out in case they just finished an order
		Utility.clearSessionCart(self.storeService,self.dataService,self.toolsService);

		self.watchRouteParams();
		self.getShoppingCart();
	}

	setupGateway() {
		const self = this;
		const postData = {
			subscriptionName: self.storeService.gatewaySubscriptionName
		};

		self.dataService.post<ShoppingCart>(`/Gateway/Init`, postData)
			.then(response => {
				self.toolsService.ProcessHttpResponse(response, () => {
					// nothing really to do there, errors would be handled by outer call
				});
			});
	}

	getShoppingCart() {
		const self = this;
		self.dataService.get<ShoppingCart>(`/ShoppingCart/${self.registerId}`, ShoppingCart)
			.then(response => {
				self.toolsService.ProcessHttpResponse(response, () => {
					self.storeService.shoppingCart = response.data;
				});
			});
	}

	onPageChange(page: pages) {
		this.currentPage = page;
	}

	onNotify(event) {
		const self = this;

		if (event === 15000) {
			self.timerModalLink.nativeElement.click();
		} else if (event === 1000) {
			self.timeout = setTimeout(async () => {
				self.timerModalLink.nativeElement.click();
				await self.cancelOrder();
			}, 1000);
		}
	}

	cancelTimeout() {
		if (this.timeout) {
			clearTimeout(this.timeout);
		}
	}

	@HostListener('click', ['$event.target']) onClick(ctrl) {
		// don't reset the timer why we programmatically click the link to show/hide the timer dialog
		if (ctrl.dataset.target !== '#timer-modal') {
			this.cd1.restart();
		}
	}

	@HostListener('keydown') onKeyDown() {
		this.cd1.restart();
	}

	 async cancelOrder() {
		const self = this;
        await Utility.clearSessionCart(self.storeService,self.dataService,self.toolsService);
		if (self.registerId) {
			if (self.kioskId) {
				self.router.navigate([`/dashboard/${self.registerId}/${self.kioskId}`]);
			} else {
				self.router.navigate([`/dashboard/${self.registerId}`]);
			}
		}
	}
}
